import React from 'react';
import RoutesComponent from './router/Routes';
import { AuthProvider } from './store/authStore/AuthContext';

export const App = () => {
  return (
    <AuthProvider>
      <RoutesComponent />
    </AuthProvider>
  );
};
